import styled, { css } from 'styled-components';
import { layout, media, remCalc } from '@prisjakt/ui-base';

import WinnersComponent from './components/winners';

import { SECTION_TITLE_SIZE } from './constants';

export const SotyPage = styled.div``;

export const WinnersSection = styled.section`
  margin-bottom: ${layout.spacing.medium};
`;

export const Search = styled.div`
  margin-top: ${layout.spacing.small};
`;

export const SectionTitle = styled.h2(
  props => css`
    display: flex;
    align-items: center;
    font-size: ${remCalc(SECTION_TITLE_SIZE)};
    border-bottom: 1px solid ${props.theme.lines.secondary};
    padding-bottom: ${layout.spacing.small};
    margin-top: ${layout.spacing.xSmall};
    margin-left: ${layout.spacing.xSmall};
    margin-right: ${layout.spacing.xSmall};
    padding-left: ${layout.spacing.xSmall};
    padding-right: ${layout.spacing.xSmall};

    ${media.smallOnly`
      margin-left: 0;
      margin-right: 0;
      padding-left: ${layout.spacing.small};
      padding-right: ${layout.spacing.small};
    `}
  `
);

export const Winners = styled(WinnersComponent)`
  padding: 0 ${layout.spacing.small};
  margin-top: ${layout.spacing.small};
`;
